import { useEffect } from 'react';
import { useNotificationStore, TOAST_DURATION_MS } from '@/store/notificationStore';
import { useT } from '@/i18n/useT';

export function ToastRegion() {
  const toasts = useNotificationStore(s => s.toasts);
  const dismiss = useNotificationStore(s => s.dismiss);
  const t = useT();

  useEffect(() => {
    if (toasts.length > 0) {
      const timer = setTimeout(() => {
        const first = toasts[0];
        if (first) dismiss(first.id);
      }, TOAST_DURATION_MS);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [toasts, dismiss]);

  if (toasts.length === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '24px',
      right: '24px',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      zIndex: 9999,
      pointerEvents: 'none',
    }}>
      {toasts.map(toast => {
        const bg = toast.kind === 'error' ? 'var(--color-danger, #ef4444)' : 
                   toast.kind === 'success' ? 'var(--color-success, #22c55e)' :
                   'var(--color-bg-elevated, #333)';
        return (
          <div key={toast.id} style={{
            backgroundColor: bg,
            color: 'white',
            padding: '12px 20px',
            borderRadius: '6px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            fontSize: '14px',
            pointerEvents: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px'
          }}>
            <span>{t(toast.messageKey)}</span>
            <button 
              onClick={() => dismiss(toast.id)}
              style={{
                background: 'none',
                border: 'none',
                color: 'rgba(255,255,255,0.7)',
                cursor: 'pointer',
                padding: '4px',
                display: 'flex'
              }}
            >
              ✕
            </button>
          </div>
        );
      })}
    </div>
  );
}
